<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid d-flex justify-content-between gap-5">
      <div
        class="card rounded-10 p-4 text-center d-flex flex-column justify-content-evenly"
        style="width: 450px; height: 400px"
      >
        <div class="d-flex gap-3">
          <div>
            <img src="/images/Frame3839.png" width="70px" />
          </div>
          <div class="text-start mt-2">
            <strong class="d-block">{{ ldata.name?.toUpperCase() }}</strong>
            <span class="text-muted">{{ ldata.email }}</span>
          </div>
        </div>
        <div class="text-start mt-5">
          <span class="text-muted">OVERVIEW</span>
          <ul class="list-unstyled mt-4">
            <li
              v-for="(item, index) in items"
              :key="index"
              class="d-flex align-items-center mb-3"
              @click="selected = item.text"
              role="button"
              :class="[
                {
                  'selected-item': selected === item.text,
                  'text-muted': selected !== item.text,
                },
              ]"
            >
              <i :class="[item.icon, 'me-2 fs-6']"></i>
              <span
                :class="[
                  'fs-6 text-capitalize',
                  {
                    'selected-item': selected === item.text,
                    'text-muted': selected !== item.text,
                  },
                ]"
              >
                {{ item.text }}
              </span>
            </li>
          </ul>
        </div>
        <div class="mt-4 mb-3">
          <button
            class="btn w-100 btn-warning"
            style="border-radius: 12px; height: 50px"
            type="submit"
            @click="openDialog"
          >
            <span class="fw-bold">LOG OUT</span>
          </button>
        </div>
      </div>
      <div style="width: 100%" v-if="selected === 'Profile'">
        <div class="card">
          <div class="position-relative">
            <img
              src="/images/dp2_bg.jpg"
              class="w-100"
              style="height: 130px; object-fit: cover"
            />

            <div
              class="position-absolute start-1"
              style="bottom: -50px; left: 25px"
            >
              <img
                src="/images/dp_logo.png"
                class="rounded-circle border border-3 border-white shadow"
                width="120"
              />
            </div>
          </div>
          <div class="text-start p-3" style="margin-left: 130px">
            <strong class="fs-4">{{ ldata.name?.toUpperCase() }}</strong>
            <br />
            <div class="d-flex justify-content-between">
              <span class="text-muted">{{ ldata.role }}</span>
              <span class="text-muted">{{ ldata.phone_number }}</span>
              <span class="text-muted">{{ ldata.email }}</span>
              <button
                data-bs-toggle="modal"
                data-bs-target="#editModal"
                class="btn border border-warning text-warning"
              >
                Edit
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex gap-5">
          <div class="card p-4" style="width: 50%">
            <strong class="text-start fs-5">Personal Information</strong>
            <div class="text-start mt-4 text-muted">
              <span class="pl-4 text-muted">Phone Number :</span> <br />
              <p class="pl-4 mt-2" style="font-size: 16px">{{ mobile }}</p>
              <hr />
            </div>
            <div class="text-start text-muted">
              <span class="pl-4 text-muted">Role :</span> <br />
              <p class="pl-4 mt-2" style="font-size: 16px">{{ role }}</p>
              <hr />
            </div>
            <div class="text-start text-muted">
              <span class="pl-4 text-muted">Admin ID :</span> <br />
              <p class="pl-4 mt-2" style="font-size: 16px">{{ rbID }}</p>
              <hr />
            </div>
            <div class="text-start text-muted">
              <span class="pl-4 text-muted">ID :</span> <br />
              <p class="pl-4 mt-2" style="font-size: 16px">{{ uid }}</p>
              <hr />
            </div>
            <div class="text-start text-muted">
              <span class="pl-4 text-muted">Created AT :</span> <br />
              <p class="pl-4 mt-2" style="font-size: 16px">{{ createdAt }}</p>
            </div>
          </div>
          <div class="card p-4" style="width: 50%">
            <strong class="text-start fs-5">Recent Login History</strong>
            <div class="text-start mt-4 text-muted">
              <span class="pl-4 text-muted">{{ lastLogin }}</span>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="editModal"
        tabindex="-1"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          class="modal-dialog modal-dialog-centered"
          style="max-width: 850px"
        >
          <div class="modal-content text-start">
            <div class="modal-header bg-warning text-dark p-4">
              <h5 class="modal-title" id="editModalLabel">Edit Profile</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <form>
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input v-model="name" type="text" class="form-control" />
                </div>
                <div class="mb-3">
                  <label class="form-label">Phone Number</label>
                  <input v-model="mobile" type="text" class="form-control" />
                </div>
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input v-model="email" type="text" class="form-control" />
                </div>
                <div class="mb-3">
                  <label class="form-label">Role</label>
                  <select v-model="role" type="text" class="form-control">
                    <option value="superadmin">Super Admin</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn border border-warning text-warning w-25"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                class="btn w-25"
                :class="{
                  'btn-warning': !v$.$invalid,
                  'disabled-btn': v$.$invalid,
                }"
                type="submit"
                :disabled="v$.$invalid"
                @click="updateAdmin"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span v-else class="fw-bold">Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ToastNotification ref="toast" />
    <DeleteDialog
      title="Are you want to Log Out ?"
      message="Click yes to logout"
      :cancel-text="'No'"
      :confirm-text="'Yes'"
      ref="deleteDialog"
      @confirm="logout"
    />
  </div>
</template>

<script>
import { updateAdmin } from "@/apis/admin";
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import useVuelidate from "@vuelidate/core";
import {
  required,
  minLength,
  numeric,
  maxLength,
  email,
} from "@vuelidate/validators";
import Cookies from "js-cookie";

export default {
  name: "myProfile",

  methods: {
    async updateAdmin() {
      this.loading = true;

      const response = await updateAdmin(this.uid, {
        name: this.name,
        phone_number: this.mobile,
        email: this.email,
        role: this.role,
      });

      if (response.status) {
        this.$refs.toast.showToast(
          `Details Updated Succesfully !.Relogin The Site  `,
          "success"
        );

        setTimeout(() => {
          this.logout();
        }, 2000);
      } else {
        this.$refs.toast.showToast(`Oops!. Failed to Update`, "error");
      }

      this.loading = false;
    },

    logout() {
      localStorage.removeItem("ldata");
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
      this.$router.push("/login");
    },

    openDialog(value) {
      this.$refs.deleteDialog.openDialog(value);
    },
  },

  validations: {
    mobile: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    email: {
      required,
      email,
    },
    role: {
      required,
    },
    name: {
      required,
    },
  },

  data() {
    return {
      name: null,
      email: null,
      mobile: null,
      role: null,
      uid: null,

      v$: null,
      loading: false,

      items: [{ icon: "ri-user-line", text: "Profile" }],

      selected: "Profile",
    };
  },

  async mounted() {
    const {
      id,
      name,
      phone_number,
      email,
      role,
      last_login,
      created_at,
      admin_id,
    } = this.ldata;

    this.uid = id;
    this.name = name;
    this.email = email;
    this.mobile = phone_number;
    this.role = role;
    this.rbID = admin_id;
    this.lastLogin = last_login;
    this.createdAt = created_at;
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },

  computed: {
    ...mapState(useAuthStore, ["ldata"]),
  },
};
</script>

<style scoped>
.selected-item {
  background-color: #fdf5de !important;
  border-radius: 20px;
  padding: 4px 6px;
  color: black;
}
</style>
